export const checkPermission = (path) => {
  if (path === "#/aggregate-master") {
    return "AggregateMaster";
  } else if (path === "#/aggregate-master/edit") {
    return "AggregateMasterEdit";
  } else if (path === "#/hashtag-master") {
    return "HashtagMaster";
  } else if (path === "#/hashtag-master/edit") {
    return "HashtagMasterEdit";
  } else if (path === "#/platform-master") {
    return "PlatformMaster";
  } else if (path === "#/platform-master/edit") {
    return "PlatformMasterEdit";
  } else if (path === "#/event-gallery-master") {
    return "EventGallery";
  } else if (path === "#/event-gallery-master/edit") {
    return "EventGalleryEdit";
  } else if (path === "#/badge-master") {
    return "BadgeMaster";
  } else if (path === "#/badge-master/edit") {
    return "BadgeMasterEdit";
  } else if (path === "#/userrole-master") {
    return "UserroleMaster";
  } else if (path === "#/userrole-master/edit") {
    return "UserroleMasterEdit";
  } else if (path === "#/appversion-master") {
    return "AppVersionMaster";
  } else if (path === "#/appversion-master/edit") {
    return "AppVersionMasterEdit";
  } else if (path === "#/ticker-master") {
    return "TickerMaster";
  } else if (path === "#/ticker-master/edit") {
    return "TickerMasterEdit";
  } else if (path === "#/usefullink-master") {
    return "UserfulLink";
  } else if (path === "#/usefullink-master/edit") {
    return "UserfulLinkEdit";
  } else if (path === "#/guidelines-master") {
    return "Guidelines";
  } else if (path === "#/guidelines-master/edit") {
    return "GuidelinesEdit";
  } else if (path === "#/calendarEvent-master") {
    return "CalenderEvent";
  } else if (path === "#/calendarEvent-master/edit") {
    return "CalenderEventEdit";
  } else if (path === "#/bulk-upload-document") {
    return "BulkUploadDocument";
  } else if (path === "#/bulk-upload-document/edit") {
    return "BulkUploadDocumentEdit";
  } else if (path === "#/kc-bulk-upload-document") {
    return "KCBulkUploadDocument";
  } else if (path === "#/knowledgebase-master") {
    return "KnowledgebaseMaster";
  } else if (path === "#/knowledgebase-master/edit") {
    return "KnowledgebaseMasterEdit";
  } else if (path === "#/home") {
    return "Home";
  } else if (path === "#/ask-an-expert") {
    return "AskAnExpert";
  } else if (path === "#/knowledge-created-by-me") {
    return "KnowledgeCreatedByMe";
  } else if (path === "#/questions-answered-by-me") {
    return "QuestionsAnsweredByMe";
  } else if (path === "#/questions-asked-by-me") {
    return "QuestionsAskedByMe";
  } else if (path === "#/questions-for-me") {
    return "QuestionsForMe";
  } else if (path === "#/create-knowledge") {
    return "CreateKnowledge";
  } else if (path === "#/dashboard") {
    return "Dashboard";
  } else if (path === "#/dashboard/edit") {
    return "DashboardEdit";
  } else if (path === "#/report") {
    return "Report";
  } else if (path === "#/all-stories") {
    return "AllStories";
  } else if (path === "#/bookmarks") {
    return "Bookmarks";
  } else if (path === "#/calendar") {
    return "Calendar";
  } else if (path === "#/knowledge") {
    return "Knowledge";
  } else if (path === "#/knowledgeBase/:id") {
    return "KnowledgeBaseId";
  } else if (path === "#/guidelines") {
    return "Guidelines";
  } else if (path === "#/usefull-links") {
    return "UsefullLinks";
  } else if (path === "#/eventgallery") {
    return "Eventgallery";
  } else if (path === "#/eventgallery/:id") {
    return "EventgalleryId";
  } else if (path === "#/details") {
    return "Details";
  } else if (path === "#/search") {
    return "Search";
  } else if (path === "#/profile") {
    return "Profile";
  } else if (path === "#/" || path === "#/login") {
    return "Login";
  } else {
    return "";
  }
};
